import { render, staticRenderFns } from "./FormAssignCompany.vue?vue&type=template&id=606b9fc4"
import script from "./FormAssignCompany.vue?vue&type=script&lang=js"
export * from "./FormAssignCompany.vue?vue&type=script&lang=js"
import style0 from "./FormAssignCompany.vue?vue&type=style&index=0&id=606b9fc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports